<template>
    <div>
        <Alert
            v-if="queryType=='edit'"
            type="error"
            class="color-error margin-left-15"
        >{{$t('erp.channelbase.safe_tip', { defaultValue: '考虑到安全性，此处不展示此前填入的参数信息。留空即表示不更改原参数值。若有参数变更，请重新填写。' })}}</Alert>
        <compFormQuery
            v-if="queryType=='query'"
            class="margin-top-15 margin-right-15"
            :formdata="getInterface"
            :value="formData"
        ></compFormQuery>
        <compFormEdit
            v-else
            class="margin-top-15 margin-right-15"
            :formdata="getInterface"
            v-model="formData"
            ref="otherform"
        />
    </div>
</template>

<script>
// import { setTimeout } from 'timers';
export default {
    props: ["queryType", "formType", "queryformData", "activedtype"],
    components: {
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
    },
    data() {
        return {
            amazonData: [
                { label: this.$t('erp.channelbase.product', { defaultValue: "产品" }), trueValue: "product" },
                { label: this.$t('erp.channelbase.order', { defaultValue: "订单" }), trueValue: "order" },
                { label: this.$t('ucadm.notice.report', { defaultValue: "报表" }), trueValue: "report" },
                { label: this.$t('erp.channelbase.caiwu', { defaultValue: "财务" }), trueValue: "finance" },
                { label: this.$t('erp.channelbase.inbound', { defaultValue: "进库" }), trueValue: "inbound" },
                { label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }), trueValue: "outbound" },
                { label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }), trueValue: "stock" },
            ],
            amzonNewFlag: [
                { label: this.$t('erp.channelbase.product', { defaultValue: "产品" }), trueValue: "product" },
                { label: this.$t('erp.channelbase.order', { defaultValue: "订单" }), trueValue: "order" },
                { label: this.$t('ucadm.notice.report', { defaultValue: "报表" }), trueValue: "report" },
                { label: this.$t('erp.channelbase.caiwu', { defaultValue: "财务" }), trueValue: "finance" },
                { label: this.$t('erp.channelbase.inbound', { defaultValue: "进库" }), trueValue: "inbound" },
                { label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }), trueValue: "outbound" },
                { label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }), trueValue: "stock" },
                { label: this.$t('erp.channelbase.get_afn_order', { defaultValue: "获取afn订单" }), trueValue: "afnorder" },
            ],
            formData: {
                new_flag: [],
            },
            alist: [
                { label: this.$t('erp.channelbase.north_america', { defaultValue: "北美" }), areaCode: "North America" },
                { label: this.$t('erp.channelbase.europe', { defaultValue: "欧洲" }), areaCode: "Northwest Europe" },
                { label: this.$t('erp.channelbase.asia', { defaultValue: "亚洲" }), areaCode: "Asia" },
            ],
            name: this.$t('erp.channelbase.north_america', { defaultValue: "北美" }),
            styWidth: 210,
            content: "",
            showquery: false,
            showtype: this.$route.query.type || this.activedtype || this.formType,
        };
    },
    watch: {
        queryformData: {
            immediate: true,
            deep: true,
            handler(val) {
                // console.log(val,'233232')
                this.formData = { ...this.formData, ...val };
            },
        },
    },
    computed: {
        getInterface() {
            this.showquery =
                this.queryType == "edit" || this.queryType == "query";
            // console.log(this.showtype,'showtype')
            let htls = this.showtype.toLowerCase();
            if (htls === "amazon") {
                this.alist.map((item) => {
                    if (item.areaCode == this.formData.defaultAccount) {
                        this.name = item.label;
                    }
                });
            }
            if (htls === "amazon") return this.getAmazon;
            if (htls === "ebay") return this.getEbay;
            if (htls === "walmart") return this.getWalmart;
            if (htls === "walmart_dsv") return this.getWalmartDsv;
            if (htls === "amazonvendor") return this.getAmazonVendor;
            if (htls === "amazonvendords") return this.getAmazonVendorDs;
            if (htls === "wayfair") return this.getWayfair;
            if (htls === "yamibuy") return this.getYamibuy;
            if (htls === "overstock") return this.getOverstock;
            if (htls === "allexpress") return this.getAllexpress;
            if (htls === "houzz") return this.getHouzz;
            if (htls === "newegg") return this.getNewegg;
            if (htls === "pricefalls") return this.getPricefalls;
            if (htls === "shopify") return this.getShopify;
            if (htls === "homedepot") return this.getHomeDepot;
            if (htls === "lowes") return this.getHomeDepot;
            if (htls === "hayneedle") return this.getHayneedle;
            if (htls === "houzz_dsv") return this.getHouzzDsv;
            if (htls === "sears") return this.getSears;
            if (htls === "manomano") return this.getManomano;
            if (htls === 'eccang') return this.getEccang;
            if (htls === 'costco') return this.getCostco;
            if (htls === 'shipstation') return this.getShipstation;

            return this.getOthersForm;
        },
        getAmazon() {
            // console.log(this.queryformData)
            this.content = this.queryformData.parentAccountFlag;
            // console.log(this.queryformData.parentAccountFlag)
            if (this.queryformData.parentAccountFlag == "") {
                this.formData.parentAccountFlag = true;
            }
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: this.$t('erp.channelbase.default_main_account', { defaultValue: '默认为主账号' }) + "(" + this.name + ")",
                    show: this.queryType == "edit",
                    key: "parentAccountFlag",
                    tag: "vCheckbox",
                    span: 6,
                    on: {
                        "on-change": (value) => {
                            this.$VModal.default(
                                {
                                    title: this.$t('erp.channelbase.set_main_account', { defaultValue: "设置主账号" }),
                                    // width: 800,
                                    content:
                                        `<div class='text-center'>${this.$t('erp.channelbase.same_main_account_tip', { defaultValue: '同一个渠道名称下，已有默认主账号' })}<span class=color-primary>` +
                                        this.content +
                                        `</span>${this.$t('erp.channelbase.is_direct_update', { defaultValue: '，是否直接更新？选择是，则更新该字段并保存；选择否则不更新该字段仅保存其它信息。' })}</div>`,
                                },
                                {
                                    "on-cancel": () => {
                                        // console.log(this)
                                        this.$set(
                                            this.formData,
                                            "parentAccountFlag",
                                            false
                                        );
                                    },
                                    "on-confirm": () => {
                                        this.$set(
                                            this.formData,
                                            "parentAccountFlag",
                                            true
                                        );
                                        // console.log(value)
                                        this.$VModal.destroy();
                                    },
                                }
                            );
                        },
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                    props: {
                        trueValue: true,
                        strict: false,
                    },
                },
                {
                    label: "Seller ID",
                    key: "sellerId",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // {
                //     label: "mwsAuthToken",
                //     key: "mwsAuthToken",
                //     required: false,
                //     formItem: {
                //         labelWidth: this.styWidth,
                //     },
                // },
                // {
                //     label: "merchantToken",
                //     key: "merchantToken",
                //     required: false,
                //     formItem: {
                //         labelWidth: this.styWidth,
                //     },
                // },
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        return this.amzonNewFlag.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    options: this.amzonNewFlag,
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
        getEbay() {
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "EbayToken",
                    show: this.queryType == "query",
                    render: () => {
                        return (
                            <div
                                title={this.formData.ebayToken}
                                style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                            >
                                {this.formData.ebayToken}
                            </div>
                        );
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "EbayToken",
                    key: "ebayToken",
                    show: this.queryType == "edit",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // {
                // 	label: "Ebay授权",
                //     key: "shipAddress",
                //     show:false,
                //     formItem:{
                //         labelWidth:this.styWidth,
                //     }
                // },
            ];
        },
        getWalmart() {
            this.$set(
                this.formData,
                "host",
                "https://marketplace.walmartapis.com"
            );
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // {
                // 	label: "consumerId",
                //     key: "consumerId",
                //     required:false,
                //     formItem:{
                //         labelWidth:this.styWidth,
                //     }
                // },
                // {
                // 	label: "privateEncodedStr",
                //     // key: "privateEncodedStr",
                //     show:this.queryType == 'query',
                //     render:()=>{
                //         return <div title={this.formData.privateEncodedStr} style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{this.formData.privateEncodedStr}</div>
                //     },
                //     formItem:{
                //         labelWidth:this.styWidth,
                //     }
                // },
                // {
                // 	label: "privateEncodedStr",
                //     key: "privateEncodedStr",
                //     show:this.queryType != 'query',
                //     required:false,
                //     formItem:{
                //         labelWidth:this.styWidth,
                //     }
                // },
                {
                    label: "host",
                    key: "host",
                    query: true,
                    required: false,
                    formItem: {
                        disabled: true,
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "name",
                    key: "name",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "clientId",
                    key: "clientId",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "clientSecret",
                    key: "clientSecret",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // {
                // 	label: "type",
                //     key: "type",
                //     required:false,
                //     formItem:{
                //         labelWidth:this.styWidth,
                //     }
                // },
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        let array = [
                            {
                                trueValue: "order",
                                label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                            },
                            {
                                trueValue: "stock",
                                label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                            },
                            {
                                trueValue: "outbound",
                                label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),
                            },
                        ];
                        return array.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: [
                        {
                            trueValue: "order",
                            label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                        },
                        {
                            trueValue: "stock",
                            label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                        },
                        {
                            trueValue: "outbound",
                            label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),
                        },
                    ],
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
        getWalmartDsv() {
            this.$set(this.formData, "host", "https://api-gateway.walmart.com");
            //this.$set(this.formData, "serviceName", "Walmart Gateway API");
            //this.$set(this.formData, "correlationId", "1234hfvgtr");
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "clientId",
                    key: "clientId",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "clientSecret",
                    key: "clientSecret",
                    required: false,
                    show: this.queryType != "query",
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "clientSecret",
                    // key: "privateEncodedStr",
                    show: this.queryType == "query",
                    render: () => {
                        return (
                            <div
                                title={this.formData.clientSecret}
                                style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                            >
                                {this.formData.clientSecret}
                            </div>
                        );
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                /*{
                    label: "correlationId",
                    key: "correlationId",
                    required: false,
                    query: true,
                    formItem: {
                        disabled: true,
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "privateEncodedStr",
                    // key: "privateEncodedStr",
                    show: this.queryType == "query",
                    render: () => {
                        return (
                            <div
                                title={this.formData.privateEncodedStr}
                                style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                            >
                                {this.formData.privateEncodedStr}
                            </div>
                        );
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "privateEncodedStr",
                    key: "privateEncodedStr",
                    show: this.queryType != "query",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },*/
                {
                    label: "host",
                    key: "host",
                    required: false,
                    query: true,
                    formItem: {
                        disabled: true,
                        labelWidth: this.styWidth,
                    },
                },
                // {
                // 	label: "shipNodeList",
                //     key: "shipNodeList",
                //     required:false,
                //     formItem:{
                //         labelWidth:this.styWidth,
                //     }
                // },

                /*{
                    label: "serviceName",
                    key: "serviceName",
                    required: false,
                    query: true,
                    formItem: {
                        disabled: true,
                        labelWidth: this.styWidth,
                    },
                },*/
                // {
                // 	label: "type",
                //     key: "type",
                //     required:false,
                //     formItem:{
                //         labelWidth:this.styWidth,
                //     }
                // },
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        let array = [
                            {
                                trueValue: "order",
                                label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                            },
                            {
                                trueValue: "stock",
                                label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                            },
                            {
                                trueValue: "outbound",
                                label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),
                            },
                        ];
                        return array.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: [
                        {
                            trueValue: "order",
                            label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                        },
                        {
                            trueValue: "stock",
                            label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                        },
                        {
                            trueValue: "outbound",
                            label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),
                        },
                    ],
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },

        getAmazonVendor() {
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // {
                //     label: "ftpHost",
                //     key: "ftpHost",
                //     required: false,
                //     formItem: {
                //         labelWidth: this.styWidth,
                //     },
                // },
                // {
                //     label: "privateKey",
                //     key: "privateKey",
                //     required: false,
                //     formItem: {
                //         labelWidth: this.styWidth,
                //     },
                // },
                // {
                //     label: "downloadUser",
                //     key: "downloadUser",
                //     required: false,
                //     formItem: {
                //         labelWidth: this.styWidth,
                //     },
                // },
                // {
                //     label: "uploadUser",
                //     key: "uploadUser",
                //     required: false,
                //     formItem: {
                //         labelWidth: this.styWidth,
                //     },
                // },
                // {
                //     label: "ISAID",
                //     key: "ISAID",
                //     required: false,
                //     formItem: {
                //         labelWidth: this.styWidth,
                //     },
                // },
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        let array = [
                            {
                                trueValue: "order",
                                label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                            },
                            // {
                            //     trueValue: "stock",
                            //     label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                            // },
                            // {
                            //     trueValue: "outbound",
                            //     label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),
                            // },
                        ];
                        return array.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: [
                        {
                            trueValue: "order",
                            label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                        },
                        // {
                        //     trueValue: "stock",
                        //     label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                        // },
                        // {
                        //     trueValue: "outbound",
                        //     label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),
                        // },
                    ],
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },

        getAmazonVendorDs() {
            console.log(this.queryformData)
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "SellingPartyId",
                    key: "sellingPartyId",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // {
                //     label: "privateKey",
                //     key: "privateKey",
                //     required: false,
                //     formItem: {
                //         labelWidth: this.styWidth,
                //     },
                // },
                // {
                //     label: "downloadUser",
                //     key: "downloadUser",
                //     required: false,
                //     formItem: {
                //         labelWidth: this.styWidth,
                //     },
                // },
                // {
                //     label: "uploadUser",
                //     key: "uploadUser",
                //     required: false,
                //     formItem: {
                //         labelWidth: this.styWidth,
                //     },
                // },
                // {
                //     label: "ISAID",
                //     key: "ISAID",
                //     required: false,
                //     formItem: {
                //         labelWidth: this.styWidth,
                //     },
                // },
                {
                    label: "IsLabeled",
                    key: "IsLabeled",
                    tag:'vRadio',
                    options: [{
                        trueValue: 'Y',
                        label: this.$t("erp.global.yes", { defaultValue: "是" })
                    }, {
                        trueValue: 'N',
                        label: this.$t("erp.global.no", { defaultValue: "否" })
                    }],
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        let array = [
                            {
                                trueValue: "order",
                                label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                            },
                            {
                                trueValue: "stock",
                                label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                            },
                            {
                                trueValue: "outbound",
                                label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),
                            },
                        ];
                        return array.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: [
                        {
                            trueValue: "order",
                            label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                        },
                        {
                            trueValue: "stock",
                            label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                        },
                        {
                            trueValue: "outbound",
                            label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),
                        },
                    ],
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },

        getWayfair() {
            let options = [
                {
                    trueValue: "order",
                    label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                },
                {
                    trueValue: "stock",
                    label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                },
                {
                    trueValue: "outbound",
                    label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),
                },
            ];
            this.getFormDataNewFlag(options);
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: "packingSlip",
                    // tag: "vSelect",
                    // key: "packingSlip",
                    tag: 'div',
                    show: this.queryType == "edit",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                    children: (h) => {
                        let optArr = [
                            {
                                label: "Y",
                                value: "Y",
                            },
                            {
                                label: "N",
                                value: "N",
                            },
                        ]
                        let optEleArr = optArr.map(item => {
                            return h('vOption', {
                                props: {
                                    value: item.value
                                }
                            }, item.label)
                        })
                        let select = h('vSelect', {
                            props: {
                                value: this.formData.packingSlip
                            },
                            on: {
                                'on-change': (val) => {
                                    this.formData.packingSlip = val
                                }
                            }
                        }, optEleArr)
                        return (
                            <div>
                                {select}
                                <div class="color-error">{this.$t('erp.channelbase.Y_N', { defaultValue: 'Y为下载,N为不下载' })}</div>
                            </div>
                        )
                    }
                },
                {
                    label: "packingSlip",
                    key: "packingSlip",
                    show: this.queryType == "query",
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "Client Id",
                    key: "clientId",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "Client Secret",
                    key: "clientSecret",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "IntegrationAgent",
                    key: "wayfairIntegrationAgent",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
                },
                // 查看
                {
                    label: "获取Label类型",
                    tag:"div",
                    required:false,
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    show: this.queryType == "query",
                    render: (h) => {
                        return <div>
                            <vCheckbox trueValue="Y" falseValue="N" v-model={this.formData.oldnew_flag.SPlabel} disabled>
                                <span class="font-12">SPlabel</span>
                            </vCheckbox>
                            <vCheckbox class="margin-left-10" trueValue="Y" falseValue="N" v-model={this.formData.oldnew_flag.LTLlabel} disabled>
                                <span class="font-12">LTLlabel</span>
                            </vCheckbox>
                        </div>
                    }
                },
                {
                    label: this.$t('erp.channelbase.getlabeltype', { defaultValue: "获取Label类型" }),
                    tag:"div",
                    required:false,
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    show: this.queryType == "edit",
                    children: (h) => {
                        return <div>
                            <vCheckbox trueValue="Y" falseValue="N" v-model={this.formData.oldnew_flag.SPlabel}>
                                <span class="font-12">SPlabel</span>
                            </vCheckbox>
                            <vCheckbox class="margin-left-10" trueValue="Y" falseValue="N" v-model={this.formData.oldnew_flag.LTLlabel}>
                                <span class="font-12">LTLlabel</span>
                            </vCheckbox>
                        </div>
                    }
                },
                {
                    label: "Sandbox Client Id",
                    key: "sandboxClientId",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
                },{
                    label: "Sandbox Client Secret",
                    key: "sandboxClientSecret",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
                },


                // 查看
                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"div",
                    show: this.queryType == "query",
                    required:false,
                    render: (h) => {
						return <div>
                            <div>{this.$t('erp.channelbase.order', { defaultValue: '订单' })}<Tooltip content={this.$t('erp.channelbase.wayfairorder', { defaultValue: "订单说明" })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>：
                                    <RadioGroup value={this.formData.oldnew_flag.order}>
                                        <Radio label="N" disabled>
                                            <span class="font-12">{this.$t('erp.channelbase.nobutt', { defaultValue: "不对接" })}</span>
                                        </Radio>
                                        <Radio label="T" disabled>
                                            <span class="font-12">{this.$t('erp.channelbase.testenvir', { defaultValue: "测试环境" })}</span>
                                        </Radio>
                                        <Radio label="Y" disabled>
                                            <span class="font-12">{this.$t('erp.channelbase.prodenvir', { defaultValue: "生产模式" })}</span>
                                        </Radio>
                                    </RadioGroup>
                            </div>
                            <div>{this.$t('fbb.adjustment.list_inventory', { defaultValue: '库存' })}<Tooltip content={this.$t('erp.channelbase.wayfairstock', { defaultValue: "库存" })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>：
                                    <RadioGroup value={this.formData.oldnew_flag.stock}>
                                        <Radio label="N" disabled>
                                            <span class="font-12">{this.$t('erp.channelbase.nobutt', { defaultValue: "不对接" })}</span>
                                        </Radio>
                                        <Radio label="T" disabled>
                                            <span class="font-12">{this.$t('erp.channelbase.testenvir', { defaultValue: "测试环境" })}</span>
                                        </Radio>
                                        <Radio label="Y" disabled>
                                            <span class="font-12">{this.$t('erp.channelbase.prodenvir', { defaultValue: "生产模式" })}</span>
                                        </Radio>
                                    </RadioGroup>
                            </div>
                            <div>{this.$t('erp.channelbase.outbound', { defaultValue: '出库' })}<Tooltip content={this.$t('erp.channelbase.wayfairoutbound', { defaultValue: "出库" })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>：
                                    <RadioGroup value={this.formData.oldnew_flag.outbound}>
                                        <Radio label="N" disabled>
                                            <span class="font-12">{this.$t('erp.channelbase.nobutt', { defaultValue: "不对接" })}</span>
                                        </Radio>
                                        <Radio label="T" disabled>
                                            <span class="font-12">{this.$t('erp.channelbase.testenvir', { defaultValue: "测试环境" })}</span>
                                        </Radio>
                                        <Radio label="Y" disabled>
                                            <span class="font-12">{this.$t('erp.channelbase.prodenvir', { defaultValue: "生产模式" })}</span>
                                        </Radio>
                                    </RadioGroup>
                            </div>
                            <div>{this.$t('erp.channelbase.product', { defaultValue: '产品' })}<Tooltip content={this.$t('erp.channelbase.wayfairproduct', { defaultValue: "产品" })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>：
                                    <RadioGroup value={this.formData.oldnew_flag.product}>
                                        <Radio label="N" disabled>
                                            <span class="font-12">{this.$t('erp.channelbase.nobutt', { defaultValue: "不对接" })}</span>
                                        </Radio>
                                        <Radio label="T" disabled>
                                            <span class="font-12">{this.$t('erp.channelbase.testenvir', { defaultValue: "测试环境" })}</span>
                                        </Radio>
                                        <Radio label="Y" disabled>
                                            <span class="font-12">{this.$t('erp.channelbase.prodenvir', { defaultValue: "生产模式" })}</span>
                                        </Radio>
                                    </RadioGroup>
                            </div>
                        </div>
					},
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
                // 编辑
                {
					label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag:"div",
                    show: this.queryType == "edit",
                    required:false,
                    children: (h) => {
						return <div>
                            <div>{this.$t('erp.channelbase.order', { defaultValue: '订单' })}<Tooltip content={this.$t('erp.channelbase.wayfairorder', { defaultValue: "订单说明" })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>：
                                    <RadioGroup v-model={this.formData.oldnew_flag.order}>
                                        <Radio label="N">
                                            <span class="font-12">{this.$t('erp.channelbase.nobutt', { defaultValue: "不对接" })}</span>
                                        </Radio>
                                        <Radio label="T">
                                            <span class="font-12">{this.$t('erp.channelbase.testenvir', { defaultValue: "测试环境" })}</span>
                                        </Radio>
                                        <Radio label="Y">
                                            <span class="font-12">{this.$t('erp.channelbase.prodenvir', { defaultValue: "生产模式" })}</span>
                                        </Radio>
                                    </RadioGroup>
                            </div>
                            <div>{this.$t('fbb.adjustment.list_inventory', { defaultValue: '库存' })}<Tooltip content={this.$t('erp.channelbase.wayfairstock', { defaultValue: "库存" })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>：
                                    <RadioGroup v-model={this.formData.oldnew_flag.stock}>
                                        <Radio label="N">
                                            <span class="font-12">{this.$t('erp.channelbase.nobutt', { defaultValue: "不对接" })}</span>
                                        </Radio>
                                        <Radio label="T">
                                            <span class="font-12">{this.$t('erp.channelbase.testenvir', { defaultValue: "测试环境" })}</span>
                                        </Radio>
                                        <Radio label="Y">
                                            <span class="font-12">{this.$t('erp.channelbase.prodenvir', { defaultValue: "生产模式" })}</span>
                                        </Radio>
                                    </RadioGroup>
                            </div>
                            <div>{this.$t('erp.channelbase.outbound', { defaultValue: '出库' })}<Tooltip content={this.$t('erp.channelbase.wayfairoutbound', { defaultValue: "出库" })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>：
                                    <RadioGroup v-model={this.formData.oldnew_flag.outbound}>
                                        <Radio label="N">
                                            <span class="font-12">{this.$t('erp.channelbase.nobutt', { defaultValue: "不对接" })}</span>
                                        </Radio>
                                        <Radio label="T">
                                            <span class="font-12">{this.$t('erp.channelbase.testenvir', { defaultValue: "测试环境" })}</span>
                                        </Radio>
                                        <Radio label="Y">
                                            <span class="font-12">{this.$t('erp.channelbase.prodenvir', { defaultValue: "生产模式" })}</span>
                                        </Radio>
                                    </RadioGroup>
                            </div>
                            <div>{this.$t('erp.channelbase.product', { defaultValue: '产品' })}<Tooltip content={this.$t('erp.channelbase.wayfairproduct', { defaultValue: "产品" })} placement="top"> <Icon class="font-14" type="md-help-circle" /> </Tooltip>：
                                    <RadioGroup v-model={this.formData.oldnew_flag.product}>
                                        <Radio label="N">
                                            <span class="font-12">{this.$t('erp.channelbase.nobutt', { defaultValue: "不对接" })}</span>
                                        </Radio>
                                        <Radio label="T">
                                            <span class="font-12">{this.$t('erp.channelbase.testenvir', { defaultValue: "测试环境" })}</span>
                                        </Radio>
                                        <Radio label="Y">
                                            <span class="font-12">{this.$t('erp.channelbase.prodenvir', { defaultValue: "生产模式" })}</span>
                                        </Radio>
                                    </RadioGroup>
                            </div>
                        </div>
					},
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                },
            ];
        },

        getYamibuy() {
            let options = [
                {
                    trueValue: "order",
                    label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                },
                {
                    trueValue: "stock",
                    label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                },
                {
                    trueValue: "outbound",
                    label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),
                },
            ];
            this.getFormDataNewFlag(options);
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: " App Key",
                    key: "app_key",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: " App Secret",
                    key: "app_secret",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },

                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        let array = [
                            {
                                trueValue: "order",
                                label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                            },
                            {
                                trueValue: "stock",
                                label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                            },
                            {
                                trueValue: "outbound",
                                label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),
                            },
                        ];
                        return array.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: options,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },

        getOverstock() {
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "username",
                    key: "username",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "password",
                    key: "password",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "domain",
                    key: "domain",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        return this.amazonData.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: this.amazonData,
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
        getAllexpress() {
            let options = [
                {
                    trueValue: "product",
                    label: this.$t('erp.channelbase.product', { defaultValue: "产品" }),
                },
                {
                    trueValue: "order",
                    label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                },
                {
                    trueValue: "stock",
                    label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                },
            ];
            this.getFormDataNewFlag(options);
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "aliClientId",
                    key: "aliClientId",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "aliAppsecret",
                    key: "aliAppsecret",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "aliRefreshtoken",
                    key: "aliRefreshtoken",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        let array = [
                            {
                                trueValue: "product",
                                label: this.$t('erp.channelbase.product', { defaultValue: "产品" }),
                            },
                            {
                                trueValue: "order",
                                label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                            },
                            {
                                trueValue: "stock",
                                label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                            },
                        ];
                        return array.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: options,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
        getHouzz() {
            let options = [
                {
                    trueValue: "product",
                    label: this.$t('erp.channelbase.product', { defaultValue: "产品" }),
                },
                {
                    trueValue: "order",
                    label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                },
                {
                    trueValue: "stock",
                    label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                },
            ];
            this.getFormDataNewFlag(options);
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "houzzUsername",
                    key: "houzzUsername",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "houzzToken",
                    key: "houzzToken",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "appname",
                    key: "appname",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        let array = [
                            {
                                trueValue: "product",
                                label: this.$t('erp.channelbase.product', { defaultValue: "产品" }),
                            },
                            {
                                trueValue: "order",
                                label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                            },
                            {
                                trueValue: "stock",
                                label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                            },
                        ];
                        return array.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: options,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
        getNewegg() {
            let options = [
                {
                    trueValue: "product",
                    label: this.$t('erp.channelbase.product', { defaultValue: "产品" }),
                },
                {
                    trueValue: "order",
                    label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                },
                {
                    trueValue: "stock",
                    label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                },
            ];
            this.getFormDataNewFlag(options);
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "Seller Id",
                    key: "neweggSellerId",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "Secret Key",
                    key: "neweggSecretKey",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "Authorization",
                    key: "neweggAuthorization",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },

                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        let array = [
                            {
                                trueValue: "product",
                                label: this.$t('erp.channelbase.product', { defaultValue: "产品" }),
                            },
                            {
                                trueValue: "order",
                                label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                            },
                            {
                                trueValue: "stock",
                                label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                            },
                        ];
                        return array.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: options,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
        getPricefalls() {
            let options = [
                {
                    trueValue: "order",
                    label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                },
                {
                    trueValue: "stock",
                    label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                },
            ];
            this.getFormDataNewFlag(options);
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "ftpAdrr",
                    key: "ftp_adrr",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "ftpPort",
                    key: "ftp_port",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "ftpUser",
                    key: "ftp_user",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "ftpPass",
                    key: "ftp_pass",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        let array = [
                            {
                                trueValue: "order",
                                label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                            },
                            {
                                trueValue: "stock",
                                label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                            },
                        ];
                        return array.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: options,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
        getShopify() {
            let options = [{
                    trueValue: 'product',
                    label: this.$t('erp.channelbase.product', { defaultValue: '产品' })
                },{
                    trueValue: 'order',
                    label: this.$t('erp.channelbase.order', { defaultValue: '订单' })
                },{
                    trueValue: 'report',
                    label: this.$t('ucadm.notice.report', { defaultValue: '报表' })
                }, {
                    trueValue: 'stock',
                    label: this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),
                },{
                    trueValue: 'outbound',
                    label: this.$t('erp.channelbase.outbound', { defaultValue: '出库' })
                }];
            this.getFormDataNewFlag(options);
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "apiKey",
                    key: "apiKey",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "password",
                    key: "password",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "hostname",
                    key: "hostname",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },

                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        let array = options
                        return array.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: options,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
        getHomeDepot() {
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "ftpHost",
                    key: "ftpHost",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "ftpUsername",
                    key: "ftpUsername",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "ftpPassword",
                    key: "ftpPassword",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "port",
                    key: "port",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "paymentId",
                    key: "paymentId",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        return this.amazonData.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: this.amazonData,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
        getHayneedle() {
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "ftpHost",
                    key: "ftpHost",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "ftpUsername",
                    key: "ftpUsername",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "ftpPassword",
                    key: "ftpPassword",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "ftpAccount",
                    key: "ftpAccount",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "port",
                    key: "port",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "senderId",
                    key: "senderId",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "receiverId",
                    key: "receiverId",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        return this.amazonData.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: this.amazonData,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
        getHouzzDsv() {
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "appname",
                    key: "appname",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "houzzUsername",
                    key: "houzzUsername",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "houzzToken",
                    key: "houzzToken",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        return this.amazonData.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: this.amazonData,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
        getSears() {
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "searssellerId",
                    key: "searssellerId",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "emailAdrr",
                    key: "emailAdrr",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "searsToken",
                    key: "searsToken",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // {
                // 	label: "flag",
                //     key: "flag",
                //     required:false,
                //     formItem:{
                //         labelWidth:this.styWidth,
                //     },
                // },
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        return this.amazonData.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: this.amazonData,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
        getManomano() {
            let options = [
                {
                    trueValue: "order",
                    label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                },
                {
                    trueValue: "outbound",
                    label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),
                },
            ];
            this.getFormDataNewFlag(options);
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "username",
                    key: "username",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "password",
                    key: "password",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    render: () => {
                        return options.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: options,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
        getEccang(){
            let options = [
                {
                    trueValue: "order",
                    label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                },
                {
                    trueValue: "outbound",
                    label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),
                },
                {
                    trueValue: "stock",
                    label:  this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }) ,
                },
            ];
            return [
				{
					label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
				},
                {
					label: "UserName",
                    key: "username",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
				},
                {
					label: "UserPass",
                    key: "userpass",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
				},
                {
					label: "ServiceToken",
                    key: "servicetoken",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
				},
                {
					label: "ApiUrl1",
                    key: "apiurl1",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
				},
                {
					label: "ApiUrl2",
                    key: "apiurl2",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    required:false,
                    props:{
                        placeholder:'如果开启了库存同步，请填写'
                    }
				},
                {
					label: "ecWarehouses",
                    key: "ecWarehouses",
                    formItem:{
                        labelWidth:this.styWidth,
                    },
                    popper:'若渠道指定仓库，则此参数留空不填，请前往基本设置->渠道仓库页面添加对应关系；若渠道不指定仓库，需要使用erp系统分仓，请将渠道的仓库code填入此处，若有多个请用/符号隔开',
                    required:false,
				},
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    render: () => {
                        return options.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: options,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
			];
        },
        getCostco(){
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "ftpHost",
                    key: "ftpHost",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "ftpUsername",
                    key: "ftpUsername",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "ftpPassword",
                    key: "ftpPassword",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "port",
                    key: "port",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "paymentId",
                    key: "paymentId",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "sellerParty",
                    key: "sellerParty",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "channelParty",
                    key: "channelParty",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "orderPath",
                    key: "orderPath",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "order997Path",
                    key: "order997Path",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "orderConfirmPath",
                    key: "orderConfirmPath",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "trackingPath",
                    key: "trackingPath",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "inventoryPath",
                    key: "inventoryPath",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "paymentPath",
                    key: "paymentPath",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "shippingFilePath",
                    key: "shippingFilePath",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "invoicePath",
                    key: "invoicePath",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    // options:this.amazonData,
                    render: () => {
                        return this.amazonData.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: this.amazonData,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
        getShipstation(){
            let options = [
                {
                    trueValue: "order",
                    label: this.$t('erp.channelbase.order', { defaultValue: "订单" }),
                },
                {
                    trueValue: "outbound",
                    label: this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),
                },
            ];
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "apiKey",
                    key: "apiKey",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                {
                    label: "apiSecret",
                    key: "apiSecret",
                    required: false,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                 // 查看
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "query",
                    render: () => {
                        return options.map((json) => {
                            const bool =
                                this.formData.new_flag.indexOf(json.trueValue) >
                                -1;
                            return (
                                <vCheckbox value={bool} disabled>
                                    {json.label}
                                </vCheckbox>
                            );
                        });
                    },
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
                // 编辑
                {
                    label: this.$t('erp.channelbase.start_data_type', { defaultValue: "开启同步的数据类型" }),
                    key: "new_flag",
                    tag: "vCheckbox",
                    show: this.queryType == "edit",
                    required: false,
                    options: options,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
        getOthersForm() {
            return [
                {
                    label: "Country",
                    key: "countryCode",
                    query: this.showquery,
                    formItem: {
                        labelWidth: this.styWidth,
                    },
                },
            ];
        },
    },
    methods: {
        async validate() {
            const bool = await this.$refs["otherform"].validate();
            if (!bool) {
                this.$VMessage.warning(this.$t('global.form.require', { defaultValue: "请填写必填项" }));
            }
            return true;
        },
        getFormDataNewFlag(option) {
            let result = new Set();
            if (Array.isArray(this.formData.new_flag)) {
                this.formData.new_flag.map((item) => {
                    option.map((sItem) => {
                        if (sItem.trueValue === item) {
                            result.add(item);
                        }
                    });
                });
                this.formData.new_flag = Array.from(result);
            }
        },
    },
};
</script>
